import React, { FC } from 'react';
import { Icon } from '../Icon';
import { IconButton } from '@chakra-ui/react';
import { Layout } from '../Layout';
import { i18n } from '../../../i18n';

interface ShowHidePasswordButtonProps {
  toggleShowPassword: () => void;
  showPassword: boolean;
}

export const ShowHidePasswordButton: FC<ShowHidePasswordButtonProps> = ({ showPassword, toggleShowPassword }) => {
  return (
    <IconButton
      aria-label={showPassword ? i18n.t('Hide password') : i18n.t('Show password')}
      variant="ghost"
      paddingX={0}
      isRound={true}
      onClick={toggleShowPassword}
      icon={
        <Layout pointerEvents="none">
          <Icon iconName={showPassword ? 'eye-slash' : 'eye'} prefix="fas" />
        </Layout>
      }
    />
  );
};
